import React, { Component } from 'react';
class text extends Component{

  render() {
      return (
          <div className="about-div">
            <h1>Privacy Policy</h1>
            <br/>
            <p className="font-17">
                Clever House Engineering S.R.L. built the Yanta Calculator app as a Commercial app. This SERVICE is provided by Clever House Engineering S.R.L. and is intended for use as is.
            </p>
            <p className="font-17">
                This page is used to inform visitors regarding our policies with the collection, use, and disclosure of Personal Information if anyone decided to use our Service.
            </p>
            <p className="font-17">
                If you choose to use our Service, then you agree to the collection and use of information in relation to this policy. The Personal Information that we collect is used for providing and improving the Service. We will not use or share your information with anyone except as described in this Privacy Policy.
            </p>
            <p className="font-17">
                The terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, which is accessible at Yanta Calculator unless otherwise defined in this Privacy Policy.
            </p>
            <br/>
            <span className="about_subtitle">Information Collection and Use</span>
            <br/>
            <p className="font-17">
                For a better experience, while using our Service, we may require you to provide us with certain personally identifiable information, including but not limited to full name, email, profile image. The information that we request will be retained by us and used as described in this privacy policy.
            </p>
            <p className="font-17">
                The app does use third party services that may collect information used to identify you.
            </p>
            <br/>
            <span className="about_subtitle">Log Data</span>
            <br/>
            <p className="font-17">
                We want to inform you that whenever you use our Service, in a case of an error in the app we collect data and information (through third party products) on your phone called Log Data. This Log Data may include information such as your device Internet Protocol (“IP”) address, device name, operating system version, the configuration of the app when utilizing our Service, the time and date of your use of the Service, and other statistics.
            </p>
            <br/>
            <span className="about_subtitle">Cookies</span>
            <br/>
            <p className="font-17">
                Cookies are files with a small amount of data that are commonly used as anonymous unique identifiers. These are sent to your browser from the websites that you visit and are stored on your device's internal memory.
            </p>
            <p className="font-17">
                This Service does not use these “cookies” explicitly. However, the app may use third party code and libraries that use “cookies” to collect information and improve their services. You have the option to either accept or refuse these cookies and know when a cookie is being sent to your device. If you choose to refuse our cookies, you may not be able to use some portions of this Service.
            </p>
            <br/>
            <span className="about_subtitle">Service Providers</span>
            <br/>
            <p className="font-17">
                We may employ third-party companies and individuals due to the following reasons:
                <br/>
                <span className="ab_number"> - </span>To facilitate our Service;
                <br/>
                <span className="ab_number"> - </span>To provide the Service on our behalf;
                <br/>
                <span className="ab_number"> - </span>To perform Service-related services; or
                <br/>
                <span className="ab_number"> - </span>To assist us in analyzing how our Service is used.
                <br/>
            </p>
            <p className="font-17">
                We want to inform users of this Service that these third parties have access to your Personal Information. The reason is to perform the tasks assigned to them on our behalf. However, they are obligated not to disclose or use the information for any other purpose.
            </p>
            <br/>
            <span className="about_subtitle">Security</span>
            <br/>
            <p className="font-17">
                We value your trust in providing us your Personal Information, thus we are striving to use commercially acceptable means of protecting it. But remember that no method of transmission over the internet, or method of electronic storage is 100% secure and reliable, and we cannot guarantee its absolute security.
            </p>
            <br/>
            <span className="about_subtitle">Links to Other Sites</span>
            <br/>
            <p className="font-17">
                This Service may contain links to other sites. If you click on a third-party link, you will be directed to that site. Note that these external sites are not operated by us. Therefore, we strongly advise you to review the Privacy Policy of these websites. We have no control over and assume no responsibility for the content, privacy policies, or practices of any third-party sites or services.
            </p>
            <br/>
            <span className="about_subtitle">Children’s Privacy</span>
            <br/>
            <p className="font-17">
                These Services do not address anyone under the age of 13. We do not knowingly collect personally identifiable information from children under 13. In the case we discover that a child under 13 has provided us with personal information, we immediately delete this from our servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact us so that we will be able to do necessary actions.
            </p>
            <br/>

              <br/>
              <span className="about_subtitle">Deletion of the data</span>
              <br/>
              <p className="font-17">
                  If you have authenticated using your Facebook account, you can delete your personal data by removing tye application from your settings page. After removal you will receive a confirmation number that you can use to check that your data is no longer in our system.
              </p>
              <p className="font-17">
                  From the webpage <a target="_blank" rel="noopener noreferrer" href="https://yantra.world">yantra.world</a>, after authentication, you can go to "Delete My Account" page from the menu and manually delete your account.
              </p>
              <p className="font-17">
                  You can also contact us at <a href="mailto:contact@cleverhouse-engineering.com">contact@cleverhouse-engineering.com</a>, if you want us to remove your personal data for your or if you have any other concerns or requests.
              </p>
              <br/>

            <span className="about_subtitle">Changes to This Privacy Policy</span>
            <br/>
            <p className="font-17">
                We may update our Privacy Policy from time to time. Thus, you are advised to review this page periodically for any changes. We will notify you of any changes by posting the new Privacy Policy on this page. These changes are effective immediately after they are posted on this page.
            </p>
            <br/>
            <span className="about_subtitle">Contact Us</span>
            <br/>
            <p className="font-17">
                If you have any questions or suggestions about our Privacy Policy, do not hesitate to contact us at <a href="mailto:contact@cleverhouse-engineering.com">contact@cleverhouse-engineering.com</a>
            </p>
          </div>
      )
  }
}

      
export default text;



// WEBPACK FOOTER //
// ./src/components/Policy/text.js